<template>
  <div class="innerBox">

    <h2 class="mb-4">Parts Quotation</h2>
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox" style="padding:0">
        <div class="col row">
          <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
          </div>
          <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Status</label>
            <Multiselect
              :options="completeFilter.map(x => x.completed)"
              :custom-label="opt => completeFilter.find(x => x.completed == opt).name"
              v-model="filter.checkStatus"
              placeholder="Pilih Status"
						/>
          </div>
          <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Tanggal</label>
            <!-- <flat-pickr
              v-model="selected.date"
              :config="rangeConfig"
              placeholder="Pilih Tanggal"
            ></flat-pickr> -->
            <date-range-picker 
							class="w-100 mr-4"
							v-model="selected.date"
							style="min-height:43px"
							ref="picker"
							:opens="'left'"
							:ranges="rangeOption"
							:autoApply="true"
						>
							<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
								<i class="fa fa-calendar fa-fw ml-n1"></i> 
									{{ moment(picker.startDate).format("MMM DD, Y")}} - {{ moment(picker.endDate).format("MMM DD, Y")}}
								<b class="caret"></b>
							</template>
						</date-range-picker>
          </div>
          <div class="col-md-3" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    
    <vue-universal-table
      api_url="/api/v1/workorder/listing/part-quotation"
      :buttons="vue_universal_table.buttons"
      :filter="filter"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      :process_data='vue_universal_table.process_data'
      :indexing="true"
      @onViewDetail="viewDetailWO"
    ></vue-universal-table>
  </div>
</template>

<script>
  import moment from 'moment'
  import Multiselect from 'vue-multiselect'
  import DateRangePicker from 'vue2-daterange-picker'

  export default {
    data () {
      const start = moment().startOf('year').format('YYYY-MM-DD');
      let end  = new moment().format('YYYY-MM-DD')

      return {
        moment,
        data : null,
        rangeOption : [],
        filter: {
          start: start,
          end: end,
          search : '',
          checkStatus : 'true'
        },
        completeFilter : [{
          name : 'Ongoing',
          completed : 'true'
        }, {
          name : 'History',
          completed : 'false'
        }],
        meta : null,
        data: null,
        mobile : this.isMobile(),
        selected : {
          date : {
            startDate : start,
            endDate : end,
          }
        },
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        showNewUserModal : false,
        apiLoading: true,
        vue_universal_table : {
          update: 0,
          process_data : `
            for (var i in data) { 
              data[i].log_name = data[i].log ? data[i].log.name : '-'
              data[i].step_name = data[i].step ? data[i].step.name : '-'
              data[i].show_wo = data[i].serviceType + data[i].form_code
            }`,
          buttons : [
            {
              title : 'viewDetail',
              variable : 'form_code',
              class : 'btn-outline-primary fas fa-eye'
            }
          ],
          fields : [
            {
              title : 'Work Order ID',
              variable : 'show_wo'
            },
            {
              title : 'Nomor Polisi Mobil',
              variable : 'registration',

            },
            {
              title : 'Nama Pelanggan',
              variable : 'customer_name'
            },
            {
              title : 'Tipe Mobil',
              variable : 'car_name'
            },
            {
              title : 'Perusahaan Asuransi',
              variable : 'insurance_company'
            },
            // {
            //   title : 'Status Mobil',
            //   variable : 'log_name'
            // },
            {
              title : 'Dibuat Pada',
              variable : 'created_at'
            },
          ]
        }
      }
    },
    components : {
      Multiselect,
      DateRangePicker
    },
    mounted () {
      let startingYear = 2021
      let yearNow = parseInt(new moment().format("Y"))

      for(var i = yearNow; i >= startingYear ; i--) {
        
        this.rangeOption[`S2 ${i}`] = [new Date(i , 6 , 1) , new Date(i , 12 , 0)]
        this.rangeOption[`S1 ${i}`] = [new Date(i , 0 , 1) , new Date(i , 6 , 0)]
      }
    },
    methods : {
      viewDetailWO (x) {
        this.$router.push({name : 'EstimatorSparepartDetail', params: {id : x.replace(/"/g, "")}})
      }
    },
    watch : {
      "selected.date"() {
        this.filter.start = new moment(this.selected.date.startDate).format('Y-MM-DD')
        this.filter.end = new moment(this.selected.date.endDate).format('Y-MM-DD')
      },
    }
  }
</script>

<style scoped>
  
</style>